import React from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios';
// import SVG from 'react-inlinesvg';

const SingleServices = () => {
  const [services, setServices] = useState([]);

  // eslint-disable-next-line no-undef
  const { bookingParkId, language } = pluginGlobals;

  useEffect(() => {
    axios
      .get(
        `https://api.bestpark.com/parks/${bookingParkId}/amenities?lang=${language}`,
      )
      .then((response) => {
        setServices(response.data);
      });
  }, [bookingParkId, language]);

  // <SVG src={`https://uploads.bestpark.com/uploads/amenities/${service.icon}`} width={24} height="auto" title="Menu" />

  return (
    <div>
      <ul className='park-services__list'>
        {services &&
          services.map((service) => {
            return (
              <li>
                <span>
                  <img
                    src={`https://uploads.bestpark.com/uploads/amenities/${service.icon}`}
                    alt=''
                  />
                </span>
                {service.name}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default SingleServices;
